/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The hexadecimal output is always uppercase (0–9 and A–F), which matches the convention in most code and colour codes. When you type hexadecimal in, either case is accepted, so ff and FF are read the same way.`)
};

const es_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La salida hexadecimal siempre está en mayúsculas (0–9 y A–F), que coincide con la convención en la mayoría del código y códigos de color. Cuando escribes en hexadecimal, se acepta cualquier caso, por lo que ff y FF se leen de la misma manera.`)
};

const de_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Hexadezimal-Ausgabe ist immer in Großbuchstaben (0–9 und A–F), was der Konvention in den meisten Code- und Farbcodes entspricht. Bei der Eingabe wird sowohl Groß- als auch Kleinschreibung akzeptiert, sodass ff und FF gleich gelesen werden.`)
};

const nl_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De hexadecimale uitvoer is altijd in hoofdletters (0–9 en A–F), wat overeenkomt met de conventie in de meeste code en kleurcodes. Wanneer u hexadecimaal invoert, wordt elk geval geaccepteerd, dus ff en FF worden op dezelfde manier gelezen.`)
};

const fr_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sortie hexadécimale est toujours en majuscules (0–9 et A–F), ce qui correspond à la convention dans la plupart des codes et codes couleur. Lorsque vous entrez l'hexadécimal, l'une ou l'autre casse est acceptée, donc ff et FF sont lus de la même façon.`)
};

const it_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'output esadecimale è sempre maiuscolo (0–9 e A–F), il che corrisponde alla convenzione nel codice e nei codici colore. Quando digiti esadecimale, entrambi i casi sono accettati, quindi ff e FF sono letti nello stesso modo.`)
};

const pt_br2_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A saída em hexadecimal é sempre em maiúsculas (0–9 e A–F), que corresponde à convenção na maioria dos códigos e códigos de cor. Quando você digita hexadecimal, qualquer caso é aceito, então ff e FF são lidos da mesma maneira.`)
};

const pt_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A saída de hexadecimal é sempre em maiúsculas (0–9 e A–F), que corresponde à convenção na maioria do código e códigos de cor. Quando escreve em hexadecimal, qualquer capitalização é aceite, portanto ff e FF são lidas do mesmo modo.`)
};

const ja_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十六進法出力は常に大文字（0～9 および A～F）で表示され、これはほとんどのコードと色コードの表記法に一致します。十六進法を入力する場合、両方のケースが受け入れられるため、ff と FF は同じように解釈されます。`)
};

const zh_nb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十六进制输出始终为大写（0-9 和 A-F），这与大多数代码和颜色代码中的惯例一致。输入十六进制时，大小写均可接受，因此 ff 和 FF 会被视为相同的值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_faq4_a", locale)
	if (locale === "en") return en_nb_faq4_a(inputs)
	if (locale === "es") return es_nb_faq4_a(inputs)
	if (locale === "de") return de_nb_faq4_a(inputs)
	if (locale === "nl") return nl_nb_faq4_a(inputs)
	if (locale === "fr") return fr_nb_faq4_a(inputs)
	if (locale === "it") return it_nb_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_nb_faq4_a(inputs)
	if (locale === "pt") return pt_nb_faq4_a(inputs)
	if (locale === "ja") return ja_nb_faq4_a(inputs)
	return zh_nb_faq4_a(inputs)
};